import { Eyebrow, MaskLines, Reveal } from "./Motion";
import { STEPS } from "../data/content";

export const Process = () => (
  <section id="process" data-testid="process-section" className="bg-[#161513] text-[#FAF8F5]">
    <div className="mx-auto max-w-[1440px] px-5 py-24 sm:px-10 sm:py-32">
      <div className="grid gap-8 lg:grid-cols-12">
        <div className="lg:col-span-6">
          <Eyebrow light>How it works</Eyebrow>
          <h2 className="mt-6 font-display text-4xl leading-[1.04] sm:text-5xl lg:text-6xl">
            <MaskLines lines={["Simple, calm,", <span key="i" className="italic text-[#D8C3A0]">step by step.</span>]} />
          </h2>
        </div>
        <Reveal className="lg:col-span-5 lg:col-start-8 lg:pt-14">
          <p className="text-lg leading-relaxed text-[#CFC8BD]">No overwhelming shopping trips and no fashion jargon. You always know what happens next and why.</p>
        </Reveal>
      </div>
      <div className="mt-16 grid gap-px bg-[#2E2B27] sm:grid-cols-2 lg:grid-cols-4">
        {STEPS.map((s, i) => (
          <Reveal key={s.num} delay={i * 0.1} className="h-full">
            <div className="group h-full bg-[#161513] p-8 transition-colors duration-500 hover:bg-[#1F1D1A]" data-testid={`process-step-${s.num}`}>
              <span className="font-display text-6xl text-[#A88350] transition-transform duration-500 inline-block group-hover:-translate-y-1">{s.num}</span>
              <h3 className="mt-8 font-display text-2xl">{s.title}</h3>
              <p className="mt-3 text-base leading-relaxed text-[#CFC8BD]">{s.text}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
